import React from "react"

import { Link } from "react-router-dom"
import { Box } from "@mui/system"
import CheckmarkList from "../product-marketing/CheckmarkList"

import { useSelectorTyped } from "../../../store/configureStore"
import CMSContent from "../CMSContent"

const LessonTypeSummary = () => {
  const {
    location: { searchCity, searchState },
    search: { selectedLessonType: lessonType },
  } = useSelectorTyped((state) => state)
  if (!lessonType || !searchCity || !searchState) {
    return null
  }

  const lessonTypeStateMeta = lessonType.stateMeta[searchState.toLowerCase()]
  if (!lessonTypeStateMeta) {
    // This is okay as it could happen while we're waiting for a search to happen.
    return null
  }

  return (
    <>
      <h2
        style={{
          marginBottom: 0,
          marginTop: 10,
        }}
        className="avail-label"
      >
        {lessonType.label}s
      </h2>
      {lessonTypeStateMeta.description ? (
        <p>{lessonTypeStateMeta.description}</p>
      ) : null}
      <div style={{ marginBottom: 40 }}>
        <h3 style={{ marginBottom: 8 }}>Lesson Features:</h3>
        <CheckmarkList items={lessonTypeStateMeta.features} />
      </div>
      {lessonTypeStateMeta.additionalContentId ? (
        <Box>
          <CMSContent uid={lessonTypeStateMeta.additionalContentId} />
        </Box>
      ) : null}
      <div>
        <h3 style={{ marginBottom: 8 }}>
          Looking for Prices? Check out our{" "}
          <Link to="/pricing">Pricing Page</Link>
        </h3>
      </div>
    </>
  )
}

export default LessonTypeSummary
